export const limitLetters = (letters, limit = 50) => {
  return letters.length > limit ? letters.slice(0, limit) + '...' : letters;
};
